<footer>
    <div class="container-fluid">
           <p class="text-center text-white m-0"><span class="number">2021</span> Chez les Nag's</p>
    </div>
</footer>